import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/carif.mp4';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class carif extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">Stahl- und Blechbearbeitung</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Carif</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <div className="videoContainer">
            <video id="background-video" loop autoPlay playsinline="true">
              <source src={banner1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        <div className="supMainTextLS">
          <h1>Carif</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="Carif Headquater"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="Carif Produktion"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="Carif Erosion"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>Carif ist Lieferant für Bandsägemaschinen. Seit 1948 entwickelt sich das Unternehmen stetig weiter und besticht durch seine modernen und flexiblen Maschinen auf der ganzen Welt. Carif hat sich auf halb-automatisch und automatisch Bandsägemaschinen für die Metallbearbeitung konzentriert und besticht durch Kundneorientierung sowie langjährige Erfahrung. </h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Carif ist Lieferant für Bandsägemaschinen. Seit 1948 entwickelt sich das Unternehmen stetig weiter und besticht durch seine modernen und flexiblen Maschinen auf der ganzen Welt.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="http://www.carif.it/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
          <section>
          
          <br/>
        </section>
        <section>
          <Grid className="gridUp">
            <center>
              <h1>Produkte</h1>
            </center>
            <Row className="show-grid">
              <Col  xs={12} sm={12}>
                <center>
                  <Link to="/Suppliers/Carif/Produkte"><h4 className="buttonBlue">Bandsägemaschinen</h4></Link>
                </center>
                </Col>
              </Row>
            </Grid>
            <br/>
        </section>

        </div>
    );
  }
}

export default carif;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/carif/mainPageSup.js